import api from '../token';

export const ListFaq = async () => {
  try {
    const response = await api.post('/getFaq');
    return response.data;
  } catch (error) {
   
    return [];
  }
};

